<template>
  <form>
    <div class="form-group col-xs-12 col-sm-6">
      <label for="name">Name</label>
      <input type="text" :disabled="aMenu._id" class="form-control" id="name" :value="aMenu.name" @input="updateMenuFields" placeholder="Menu name" data-field="name" />
    </div>
    <div class="form-group col-xs-12 col-sm-6">
      <label for="gender">Gender</label>
      <select class="form-control" id="gender" :value="aMenu.gender" @change="updateMenuFields" data-field="gender">
        <option value="">--Gender--</option>
        <option value="woman">Woman</option>
        <option value="man">Man</option>
      </select>
    </div>
    <div class="form-group col-xs-12 col-sm-6">
      <label for="english-message">Message</label>
      <input type="text" class="form-control" id="english-message" :value="aMenu.message" @change="updateMenuFields" data-field="message" placeholder="Message prefix (english)" />
    </div>
    <div class="form-group col-xs-12 col-sm-6">
      <label for="swahili-message">Message (Swahili)</label>
      <input type="text" class="form-control" id="swahili-message" :value="aMenu.swahili" @change="updateMenuFields" data-field="swahili" placeholder="Message prefix (swahili)" />
    </div>
    <br clear="all"/><br />
    <h3 class="text-center">Options</h3>
    <div class="form-group col-xs-12 col-sm-6">
      <input type="text" class="form-control" v-model="anOption.eng" placeholder="English option"/>
    </div>
    <div class="form-group col-xs-6 col-sm-6">
      <input type="text" class="form-control" v-model="anOption.swa" placeholder="Swahili option" />
    </div>
    <div class="form-group col-xs-6 col-sm-6">
      <input type="text" class="form-control" v-model="anOption.nextStage" placeholder="Next stage" />
    </div>
    <div class="form-group col-xs-6 col-sm-6">
      <v-select multiple taggable v-model="anOption.nextApps" :options="smsapps"></v-select>
      <!-- <input type="text" class="form-control" placeholder="Next Apps" /> -->
    </div>
    <div class="action-button">
      <button type="button" @click="addOption" class="btn btn-primary" :disabled="canAddOption">{{addOptionCaption}}</button>
    </div>
    <br /><br />
    <options v-on:edit="editAnOption" />
    <br />
     <div class="action-button">
      <button type="button" class="btn btn-primary" @click="saveMenu" :disabled="canSave">{{saveCaption}}</button>
      &nbsp; &nbsp;<button type="button" class="btn btn-danger" @click="cancel">Cancel</button>
    </div>
    <br /><br /><br />
  </form>
</template>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import { mapActions, mapGetters, mapState } from 'vuex'
import options from './allOptions'

Vue.component('v-select', vSelect)
export default {
  name: 'NewMenu',
  components: {
    options
  },
  data () {
    return {
      anOption: {
        eng: '',
        swa: '',
        nextStage: '',
        nextApps: []
      },
      saving: false
    }
  },
  computed: {
    canSave: function () {
      const { name, gender, message, swahili } = this.aMenu
      return !(name && gender && message && swahili && this.allOptions.length) || this.saving
    },
    canAddOption: function () {
      const { eng, swa, nextStage, nextApps } = this.anOption
      return !((eng && swa) && (nextStage || nextApps.length))
    },
    saveCaption: function () {
      return this.saving ? 'Saving' : 'Save Menu'
    },
    addOptionCaption: function () {
      return this.anOption._id ? 'Edit Option' : 'Add Option'
    },
    ...mapGetters({
      smsapps: 'getSmsApps'
    }),
    ...mapState({
      allOptions: state => state.menu.menuOptions,
      aMenu: state => state.menu.aMenu
    })
  },
  methods: {
    /**
     * @name addOption
     * @description add an option to list of all options
     */
    addOption () {
      const nextApps = this.anOption.nextApps.map(each => each.value)
      let option = { ...this.anOption, nextApps }
      if (this.anOption._id) {
        this.editMenuOptionAction(option)
      } else {
        option.enabled = true
        this.addMenuOption(option)
      }
      this.anOption = {
        eng: '',
        swa: '',
        nextStage: '',
        nextApps: []
      }
    },
    cancel () {
      this.anOption = {
        eng: '',
        swa: '',
        nextStage: '',
        nextApps: []
      }
      this.cancelAction()
    },
    /**
     * @description create or edit an existing menu
     */
    saveMenu () {
      this.saving = true
      this.saveMenuAction({
        ...this.aMenu,
        options: this.allOptions
      }).then(({ status, message }) => {
        this.$swal({
          type: 'success',
          text: message
        })
        this.saving = false
      }).catch(errorMessage => {
        this.$swal({
          type: 'error',
          text: errorMessage
        })
        this.saving = false
      })
    },
    updateMenuFields ({ target }) {
      this.updateMenuAction({ value: target.value, key: target.dataset.field })
    },
    editAnOption (index) {
      const labels = this.allOptions[index].nextApps.map(each => {
        // get the right label
        const app = this.smsapps.find(eachApp => eachApp.value === each)
        if (app) {
          return {
            label: app.label,
            value: each
          }
        }
        return {}
      })
      this.anOption = { ...this.allOptions[index], nextApps: labels, index }
    },
    ...mapActions([
      'getAllOptions',
      'addMenuOption',
      'saveMenuAction',
      'updateMenuAction',
      'cancelAction',
      'editMenuOptionAction'])
  },
  mounted () {
    this.getAllOptions()
  }
}
</script>




// WEBPACK FOOTER //
// new.vue?bbb269b2